import { Injectable } from '@angular/core';
import { HttpClient } from 'src/core/common/domain/http/http-client';
import { ApiService } from 'src/core/api/domain/api.service';
import { ExceptionManagerService } from 'src/core/common/domain/exceptions/exception-manager.service';
import { ApiAccessService } from 'src/core/common/domain/api-access/api-access.service';
import { ConnectivityService } from 'src/core/connection/domain/connectivity.service';
import { NoConnectionException } from 'src/core/common/domain/exceptions/no-connection-exception';
import { AttendanceRepository, CreateAttendancePunchPayload } from 'src/core/attendance/domain/attendance.repository';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { AttendancePunchTooSoonException } from 'src/core/common/domain/exceptions/attendance-punch-too-soon-exception';
import { LocalDate } from 'src/core/common/domain/date/local-date';
import { ApiCreateAttendancePunchRequest } from './api-create-attendance-punch-request';

@Injectable({
  providedIn: 'any',
})
export class HttpAttendanceRepository extends AttendanceRepository {
  constructor(
    private readonly apiAccessService: ApiAccessService,
    private readonly apiService: ApiService,
    private readonly client: HttpClient,
    private readonly connectivityService: ConnectivityService,
    private readonly exceptionManager: ExceptionManagerService
  ) {
    super();
  }

  async createPunch(punch: CreateAttendancePunchPayload): Promise<void> {
    try {
      if (!this.connectivityService.isOnline()) {
        throw new NoConnectionException();
      }

      await this.apiAccessService.renewApiAccessIfNeeded();
      const payload: ApiCreateAttendancePunchRequest = {
        punched_at: LocalDate.now().atom,
        scanned_nfc_code: punch.scannedNfcCode ?? undefined,
      };
      await this.client.post(`${this.apiService.baseUrl()}/attendance.punch`, payload, {}, true, true);
    } catch (exception) {
      // specific exceptions management
      if (exception instanceof HttpErrorResponse) {
        switch (exception.status) {
          case HttpStatusCode.TooManyRequests:
            throw AttendancePunchTooSoonException.fromError(exception);
        }
      }

      // general exceptions management
      throw this.exceptionManager.manage(exception);
    }
  }
}
